
export enum AccountSubscriptionType {
    Tms,
    ContextualSpeeding,
    Maintenance,
    Reefer,
    ReportBuilder,
    DriverDashboard,
    SmsQuota,
    EmailQuota,
    SSO
}
